import { Button, Collapse, Flex, Grid, Paper, Select, TextInput } from "@mantine/core"
import { DatePickerInput } from "@mantine/dates"
import { BroomIcon, MagnifyingGlassIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next"
import { IReference } from "../../store/General"
import { DistributingFilters } from "./distributing-filters"

type Props = {
  opened: boolean
  filters: Omit<DistributingFilters, "searchQuery">
  setFilter: <K extends keyof DistributingFilters>(key: K, value: DistributingFilters[K]) => void
  clearFilters: () => void
  deliveryNoteStatus: IReference[]
  pullSheetStatus: IReference[]
  onSearch?: () => void
}

export function DistributingFilterPanel({ opened, filters, setFilter, clearFilters, deliveryNoteStatus, pullSheetStatus, onSearch }: Props) {
  const { t } = useTranslation(["delivery", "common"])
  return (
    <Collapse expanded={opened}>
      <Paper p="md" mb="sm" withBorder radius="md" style={{ background: "var(--mantine-color-gray-0)" }}>
        <Grid>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:filter.deliveryNo")} value={filters.refCode} onChange={(e) => setFilter("refCode", e.target.value)} placeholder={t("common:actions.search", { ns: "common" })} size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <DatePickerInput label={t("delivery:filter.deliveryDate")} type="range" value={filters.deliveryDate} onChange={(v) => setFilter("deliveryDate", v)} placeholder={t("common:actions.select", { ns: "common" })} valueFormat="YYYY-MM-DD" size="sm" clearable />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:filter.buyer")} value={filters.receiverBusinessPartnerBusinessNameRefCode} onChange={(e) => setFilter("receiverBusinessPartnerBusinessNameRefCode", e.target.value)} placeholder={t("common:actions.search", { ns: "common" })} size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:filter.buyerBusiness")} value={filters.receiverBusinessProfileNameRefCode} onChange={(e) => setFilter("receiverBusinessProfileNameRefCode", e.target.value)} placeholder={t("common:actions.search", { ns: "common" })} size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:filter.receiverBranch")} value={filters.receiverBranchRefCode} onChange={(e) => setFilter("receiverBranchRefCode", e.target.value)} placeholder={t("common:actions.search", { ns: "common" })} size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:filter.salesCode")} value={filters.salesCode} onChange={(e) => setFilter("salesCode", e.target.value)} placeholder={t("common:actions.search", { ns: "common" })} size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:filter.paymentTerm")} value={filters.paymentTermDescription} onChange={(e) => setFilter("paymentTermDescription", e.target.value)} placeholder={t("common:actions.search", { ns: "common" })} size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <Select label={t("delivery:filter.deliveryStatus")} value={filters.deliveryNoteStatus} onChange={(v) => setFilter("deliveryNoteStatus", v)} data={deliveryNoteStatus.map((o) => ({ label: o.name, value: o.code }))} placeholder={t("common:actions.select", { ns: "common" })} clearable size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <Select label={t("delivery:filter.loadingStatus")} value={filters.pullSheetStatus} onChange={(v) => setFilter("pullSheetStatus", v)} data={pullSheetStatus.map((o) => ({ label: o.name, value: o.code }))} placeholder={t("common:actions.select", { ns: "common" })} clearable size="sm" />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
            <TextInput label={t("delivery:filter.deliveryStaff")} value={filters.staffFirstNameEmail} onChange={(e) => setFilter("staffFirstNameEmail", e.target.value)} placeholder={t("common:actions.search", { ns: "common" })} size="sm" />
          </Grid.Col>
        </Grid>
        <Flex justify="flex-end" gap="sm" mt="md">
          <Button variant="light" color="gray" size="sm" radius="md" leftSection={<BroomIcon size={16} />} onClick={clearFilters}>{t("common:actions.clear", { ns: "common" })}</Button>
          <Button variant="filled" color="dark" size="sm" radius="md" leftSection={<MagnifyingGlassIcon size={16} />} onClick={onSearch}>{t("common:actions.search", { ns: "common" })}</Button>
        </Flex>
      </Paper>
    </Collapse>
  )
}
